import type { Position, SerializedTile } from "./types";

/**
 * A single numbered tile. Carries animation metadata (`previousPosition`,
 * `mergedFrom`) consumed by the renderer; the engine itself only needs `value`
 * and position.
 */
export class Tile {
  x: number;
  y: number;
  value: number;

  /** Where the tile was before the current move (null if freshly spawned). */
  previousPosition: Position | null = null;

  /** The two tiles that merged to create this one (null otherwise). */
  mergedFrom: [Tile, Tile] | null = null;

  constructor(position: Position, value = 2) {
    this.x = position.x;
    this.y = position.y;
    this.value = value;
  }

  savePosition(): void {
    this.previousPosition = { x: this.x, y: this.y };
  }

  updatePosition(position: Position): void {
    this.x = position.x;
    this.y = position.y;
  }

  serialize(): SerializedTile {
    return {
      position: { x: this.x, y: this.y },
      value: this.value,
    };
  }
}
